export default "__VITE_ASSET__64ff20fd__"